import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "sonner";
import Site from "@/pages/Site";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Classes from "@/pages/Classes";
import BatchDetail from "@/pages/BatchDetail";
import Timetable from "@/pages/Timetable";
import Workshops from "@/pages/Workshops";
import CompetitionTeam from "@/pages/CompetitionTeam";
import Team from "@/pages/Team";
import Achievements from "@/pages/Achievements";
import Gallery from "@/pages/Gallery";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import PromoCodes from "@/admin/PromoCodes";
import Reviews from "@/pages/Reviews";
import Locations from "@/pages/Locations";
import Contact from "@/pages/Contact";
import Hire from "@/pages/Hire";
import Register from "@/pages/Register";
import EventDetail from "@/pages/EventDetail";
import Events from "@/pages/Events";
import Refer from "@/pages/Refer";
import LegalPage from "@/pages/LegalPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import AdminLogin from "@/admin/AdminLogin";
import ResetPassword from "@/pages/ResetPassword";
import AdminLayout from "@/admin/AdminLayout";
import Dashboard from "@/admin/Dashboard";
import HomepageEditor from "@/admin/HomepageEditor";
import SectionOrder from "@/admin/SectionOrder";
import Analytics from "@/admin/Analytics";
import AdminUsers from "@/admin/AdminUsers";
import EmailSettings from "@/admin/EmailSettings";
import Availability from "@/admin/Availability";
import AuditLog from "@/admin/AuditLog";
import CrudPage from "@/admin/CrudPage";
import ClassManager from "@/admin/ClassManager";
import MyClasses from "@/admin/MyClasses";
import AllRegistrations from "@/admin/AllRegistrations";
import Payroll from "@/admin/Payroll";
import BulkAssign from "@/admin/BulkAssign";
import GoogleReviews from "@/admin/GoogleReviews";
import GalleryAdmin from "@/admin/GalleryAdmin";
import EmailLog from "@/admin/EmailLog";
import Referrals from "@/admin/Referrals";
import "@/index.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
        <Routes>
          <Route element={<Site />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/classes" element={<Classes />} />
            <Route path="/classes/:batchId" element={<BatchDetail />} />
            <Route path="/timetable" element={<Timetable />} />
            <Route path="/workshops" element={<Workshops />} />
            <Route path="/competition-team" element={<CompetitionTeam />} />
            <Route path="/team" element={<Team />} />
            <Route path="/achievements" element={<Achievements />} />
            <Route path="/accolades" element={<Achievements />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/hire" element={<Hire />} />
            <Route path="/register/:sessionId" element={<Register />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:eventId" element={<EventDetail />} />
            <Route path="/refer/:code" element={<Refer />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/p/:slug" element={<LegalPage />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/reset-password" element={<ResetPassword />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="homepage" element={<HomepageEditor />} />
            <Route path="section-order" element={<SectionOrder />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="admin-users" element={<AdminUsers />} />
            <Route path="email-settings" element={<EmailSettings />} />
            <Route path="email-log" element={<EmailLog />} />
            <Route path="referrals" element={<Referrals />} />
            <Route path="availability" element={<Availability />} />
            <Route path="audit-log" element={<AuditLog />} />
            <Route path="class-setup" element={<ClassManager />} />
            <Route path="my-classes" element={<MyClasses />} />
            <Route path="all-registrations" element={<AllRegistrations />} />
            <Route path="payroll" element={<Payroll />} />
            <Route path="bulk-assign" element={<BulkAssign />} />
            <Route path="google-reviews" element={<GoogleReviews />} />
            <Route path="gallery" element={<GalleryAdmin />} />
            <Route path="promo-codes" element={<PromoCodes />} />
            <Route path=":section" element={<CrudPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
export default App;
